export const DEFAULT_ROOT_FONT_SIZE = 16
